export default __webpack_public_path__ + "static/ask-ai-customer-support-chatbot-f52d9be6771b96d9406c44ed43479452.png";